module.exports = __webpack_public_path__ + "img/GALLERY-SCROSS-6.526dd8a1.jpg";